import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { CustomerReportingPageRoutingModule } from './customer-reporting-routing.module';

import { CustomerReportingPage } from './customer-reporting.page';
import { SharedModule } from '@shared/shared.module';
import { CsvDownloadCardComponent } from './components/csv-download-card/csv-download-card.component';
import { TopPurchasesCardComponent } from './components/top-purchases-card/top-purchases-card.component';
import { CategoryReportChartComponent } from './components/category-report-chart/category-report-chart.component';
import { CustomerReportingComponentsSharedModule } from './components-shared/customer-reporting-components-shared.module';
import { TooltipModule } from '@app/customer-reporting/components-shared/tooltip/tooltip.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    CustomerReportingPageRoutingModule,
    CustomerReportingComponentsSharedModule,
    SharedModule,
    TooltipModule,
  ],
  declarations: [
    CustomerReportingPage,
    CsvDownloadCardComponent,
    TopPurchasesCardComponent,
    CategoryReportChartComponent,
  ],
})
export class CustomerReportingPageModule {}
